import type { SimpleStyleT } from "tweenly"
export const flexDirection: SimpleStyleT = {
    property: "flexDirection",
    value: "column",
    input: {
        type: "select",
        props: ["column", "row"],
        label: "flex direction",
    },
    render: (value, unit = undefined, type) =>
        type === "css"
            ? { property: "flex-direction", value }
            : { property: "flexDirection", value },
}

export const alignItems: SimpleStyleT = {
    property: "alignItems",
    value: "stretch",
    input: {
        type: "select",
        props: ["flex-start", "flex-end", "center", "baseline", "stretch"],
        label: "align items",
    },
    render: (value, unit = undefined, type) =>
        type === "css" ? { property: "align-items", value } : { property: "alignItems", value },
}

export const justifyContent: SimpleStyleT = {
    property: "justifyContent",
    value: "center",
    input: {
        type: "select",
        props: [
            "center",
            "flex-start",
            "flex-end",
            "space-around",
            "space-evenly",
            "space-between",
        ],
        label: "justify content",
    },
    render: (value, unit = undefined, type) =>
        type === "css"
            ? { property: "justify-content", value }
            : { property: "justifyContent", value },
}

// Flex Container - Gap
export const gap: SimpleStyleT = {
    property: "gap",
    value: 0,
    unit: "px",
    input: {
        type: "number",
        props: {
            inputProps: {
                min: 0,
                max: 200,
                step: 1,
            },
        },
        label: "gap",
    },
    render: (value, unit = "px", type) =>
        type === "css" ? { property: "gap", value: `${value}${unit}` } : { property: "gap", value },
}

// Flex Item Properties
export const flexGrow: SimpleStyleT = {
    property: "flexGrow",
    value: 0,
    input: {
        type: "number",
        props: {
            inputProps: {
                min: 0,
                max: 10,
                step: 1,
            },
        },
        label: "flex grow",
    },
    render: (value, unit = undefined, type) =>
        type === "css"
            ? { property: "flex-grow", value: String(value) }
            : { property: "flexGrow", value },
}

export const flexShrink: SimpleStyleT = {
    property: "flexShrink",
    value: 1,
    input: {
        type: "number",
        props: {
            inputProps: {
                min: 0,
                max: 10,
                step: 1,
            },
        },
        label: "flex shrink",
    },
    render: (value, unit = undefined, type) =>
        type === "css"
            ? { property: "flex-shrink", value: String(value) }
            : { property: "flexShrink", value },
}

export const flexBasis: SimpleStyleT = {
    property: "flexBasis",
    value: "auto",
    input: {
        type: "string",
        props: "",
        label: "flex basis",
    },
    render: (value, unit = undefined, type) =>
        type === "css"
            ? { property: "flex-basis", value: String(value) }
            : { property: "flexBasis", value },
}

export const alignSelf: SimpleStyleT = {
    property: "alignSelf",
    value: "auto",
    input: {
        type: "select",
        props: ["auto", "flex-start", "flex-end", "center", "baseline", "stretch"],
        label: "align self",
    },
    render: (value, unit = undefined, type) =>
        type === "css" ? { property: "align-self", value } : { property: "alignSelf", value },
}
